import "./pricingModal.css";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useNavigate } from "react-router-dom";
import { BsCheck2 } from "react-icons/bs";

function PricingModal(props: any) {
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="pricing-modal"
    >
      <Modal.Body className="p-0">
        <div className="modal-grid">
          <div className="modal-left">
            <div className="logo-section">
              <div className="app-logo">QRSharp</div>
            </div>
            <h2>Unlock this Premium feature</h2>
            <p className="description">
              {!props.message &&
                "This feature requires a premium plan to unlock. It's risk-free with a 14-day money-back guarantee."}
              {props.message === "qrlimit" &&
                "You've reached your QR code limit. Upgrade to premium for unlimited QR codes."}
              {props.message === "qredit" &&
                "QR code editing requires a premium plan to unlock. It's risk-free with a 14-day money-back guarantee."}
            </p>
            <div className="button-group">
              <Button
                variant="link"
                onClick={props.onHide}
                className="cancel-btn"
              >
                Cancel
              </Button>
              <Button onClick={props.onHide} className="upgrade-btn">
                Upgrade Plan
              </Button>
            </div>
          </div>
          <div className="modal-right">
            <div className="features-section">
              <h6>Included with the pro plan</h6>
              <ul className="features-list">
                <li>
                  <BsCheck2 /> Advanced QR customization
                </li>
                <li>
                  <BsCheck2 /> Unlimited QR codes
                </li>
                <li>
                  <BsCheck2 /> Access to premium templates
                </li>
                <li>
                  <BsCheck2 /> Priority support
                </li>
              </ul>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default PricingModal;
